import {
  PageFilterChipsSkeleton,
  PageHeroSkeleton,
  PageListScreenSkeleton
} from '@/shared/ui/Skeleton'

export const MissionsListSkeleton = () => (
  <div className="flex flex-col gap-4" aria-busy aria-label="Carregando missões">
    <PageHeroSkeleton withProgress />
    <PageFilterChipsSkeleton />
    <PageListScreenSkeleton itemCount={3} />
  </div>
)
